import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=79478916&scoped=true&"
import script from "./message-detail.vue?vue&type=script&lang=js&"
export * from "./message-detail.vue?vue&type=script&lang=js&"
import style0 from "./message-detail.vue?vue&type=style&index=0&id=79478916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79478916",
  null
  
)

export default component.exports